import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../store/Types';
import { SnackbarVariant } from "@volvo/vcdk";

const SLICE_NAME = 'notifications';

export interface NotificationItem {
  message: string;
  variant: SnackbarVariant ;
}

interface NotificationState {
  notification: NotificationItem[];
}

export const initialNotificationState: NotificationState = {
  notification: [],
};

const notificationSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialNotificationState,
  reducers: {
    addMessage: (state, { payload: message }: PayloadAction<NotificationItem>) => {
      state.notification = [...state.notification, message];
    },
    removeMessage: (state, { payload: message }: PayloadAction<NotificationItem>) => {
      state.notification = state.notification.filter(x => x.message !== message.message);
    },
  },
});

export const { addMessage, removeMessage } = notificationSlice.actions;
export const selectMessages = (state: RootState) => state.notifications.notification;

export default notificationSlice.reducer;
